import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconPhoneIphone = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconPhoneIphone",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M280-40q-33 0-56-23t-24-57v-720q0-33 24-56t56-24h400q33 0 57 24t23 56v720q0 33-23 57t-57 23zm200-100q17 0 29-11t11-29-11-28-29-12-28 12-12 28 12 29 28 11M280-320h400v-400H280z"
  })
}));
IconPhoneIphone.displayName = 'IconPhoneIphone';